/** @format */
import Cookie from 'js-cookie'
import i18n from 'kpc-react/i18n/en-US'

const lang = Cookie.get('ksc_lang')
const en = lang === 'en' ? i18n : {}

const MethodOp = [
  {
    key: '>=',
    value: lang === 'en' ? en['大于等于'] : '大于等于',
    semantic: lang === 'en' ? en['大于等于'] : '大于等于'
  },
  {
    key: '>',
    value: lang === 'en' ? en['大于'] : '大于',
    semantic: lang === 'en' ? en['大于'] : '大于'
  },
  {
    key: '<=',
    value: lang === 'en' ? en['小于等于'] : '小于等于',
    semantic: lang === 'en' ? en['小于等于'] : '小于等于'
  },
  {
    key: '=',
    value: lang === 'en' ? en['等于'] : '等于',
    semantic: lang === 'en' ? en['等于'] : '等于'
  },
  {
    key: '!=',
    value: lang === 'en' ? en['不等于'] : '不等于',
    semantic: lang === 'en' ? en['不等于'] : '不等于'
  }
]
const Method = [
  {
    key: 'max',
    value: lang === 'en' ? en['最大值'] : '最大值'
  },
  {
    key: 'min',
    value: lang === 'en' ? en['最小值'] : '最小值'
  },
  {
    key: 'avg',
    value: lang === 'en' ? en['平均值'] : '平均值'
  },
  {
    key: 'sum',
    value: lang === 'en' ? en['求和值'] : '求和值'
  },
  {
    key: 'samplecount',
    value: lang === 'en' ? en['计数'] : '计数'
  }
]
const Period = [
  {
    key: 1,
    value: lang === 'en' ? en['1分钟'] : '1分钟'
  },
  {
    key: 5,
    value: lang === 'en' ? en['5分钟'] : '5分钟'
  },
  {
    key: 15,
    value: lang === 'en' ? en['15分钟'] : '15分钟'
  },
  {
    key: 60,
    value: lang === 'en' ? en['1小时'] : '1小时'
  }
]
const EnPeriod = [
  {
    key: 1,
    value: '1m'
  },
  {
    key: 5,
    value: '5m'
  },
  {
    key: 15,
    value: '15m'
  },
  {
    key: 60,
    value: '1h'
  }
]

const MethodObj = {}
Method.forEach(function (s) {
  MethodObj[s.key] = s.value
})

const OpObj = {}
MethodOp.forEach(function (s) {
  OpObj[s.key] = s.semantic
})

enum QueryKeyEnum {
  InstanceId = '实例ID',
  InstanceName = '实例名称',
  InstanceIP = '实例IP',
  GroupName = '资源分组名称'
}

export { Method, MethodObj, MethodOp, OpObj, Period, EnPeriod, QueryKeyEnum }
